
//CpfField.js

import React, { useState } from 'react';

function CpfField({ value, onChange }) {
  const [isValid, setIsValid] = useState(true);

  const handleChange = (e) => {
    let newValue = e.target.value;
    // Remove todos os caracteres não numéricos
    newValue = newValue.replace(/\D/g, '');
    // Mantém apenas os primeiros 11 dígitos
    newValue = newValue.slice(0, 11);
    // Adiciona a máscara de CPF
    newValue = newValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    onChange(newValue);
    setIsValid(validateCpf(newValue));
  };

  const validateCpf = (cpf) => {
    // Remove todos os caracteres não numéricos
    cpf = cpf.replace(/\D/g, '');

    // Verifica se o CPF tem 11 dígitos
    if (cpf.length !== 11) return false;

    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1+$/.test(cpf)) return false;

    // Calcula os dígitos verificadores
    let sum = 0;
    let rest;
    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  };

  return (
    <div>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Digite o CPF"
        style={{ width: '200px', height: '30px', marginBottom: '0px' }}
      />
      {!isValid && <p style={{ color: 'red' }}>CPF inválido ou incompleto. Insira um CPF válido.</p>}
    </div>
  );
}

export default CpfField;